import gql from 'graphql-tag';
import { loader } from 'graphql.macro';

export const linkSettingsDetails = gql`
  fragment linkSettingsDetails on SurfaceNodeLinkSettings {
    color
    linkType
    startShape
    endShape
    linkName
    createdBy
    createdAt
    updatedBy
    ownedBy
    isVisible
    isEditable
  }
`;

export const surfaceNodePointsToFragment = loader('./index.graphql');
